import { render, staticRenderFns } from "./Triage.vue?vue&type=template&id=351e1d84&scoped=true"
import script from "./Triage.vue?vue&type=script&lang=js"
export * from "./Triage.vue?vue&type=script&lang=js"
import style0 from "./Triage.vue?vue&type=style&index=0&id=351e1d84&prod&scoped=true&lang=css"
import style1 from "./Triage.vue?vue&type=style&index=1&id=351e1d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351e1d84",
  null
  
)

export default component.exports